import type { CanonicalEventIR } from "./ir.ts";

export interface CanonicalOutboxIntent {
	readonly id: string;
	readonly eventId: string;
	readonly name: string;
	readonly payload: unknown;
}

export function projectOutboxIntents(
	events: readonly CanonicalEventIR[],
): CanonicalOutboxIntent[] {
	return events.map((event) => ({
		id: crypto.randomUUID(),
		eventId: event.id,
		name: event.name,
		payload: event.payload,
	}));
}
